import { EpimsBaseEntityDto } from './epim-base.dto';
export class OrganizationDto extends EpimsBaseEntityDto {

    OrganizationId: string;

    OrganizationName: string;
    OrganizationAddress: string;

    SectorId: string;

   
    

}